"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReviewReportConfig = exports.ReviewReportDisplayMode = exports.DevStatsType = exports.LongSlackDigestMode = void 0;
var LongSlackDigestMode;
(function (LongSlackDigestMode) {
    LongSlackDigestMode[LongSlackDigestMode["STANDARD"] = 0] = "STANDARD";
    LongSlackDigestMode[LongSlackDigestMode["TABULAR"] = 1] = "TABULAR";
})(LongSlackDigestMode = exports.LongSlackDigestMode || (exports.LongSlackDigestMode = {}));
var DevStatsType;
(function (DevStatsType) {
    DevStatsType[DevStatsType["LOC_CHANGED"] = 0] = "LOC_CHANGED";
})(DevStatsType = exports.DevStatsType || (exports.DevStatsType = {}));
var ReviewReportDisplayMode;
(function (ReviewReportDisplayMode) {
    ReviewReportDisplayMode[ReviewReportDisplayMode["STANDARD"] = 0] = "STANDARD";
})(ReviewReportDisplayMode = exports.ReviewReportDisplayMode || (exports.ReviewReportDisplayMode = {}));
exports.isReviewReportConfig = (data) => {
    return data &&
        typeof data === "object" &&
        "includeTasks" in data &&
        "includePullRequests" in data &&
        "devStats" in data &&
        "displayMode" in data &&
        "recapReportPeriodHours" in data &&
        "subjectId" in data;
};
//# sourceMappingURL=slack-digest.js.map